(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mojuri-rating-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element) || !event.target.closest('a.mjr-rating-summary')) return;
  const reviews = document.getElementById('judgeme_product_reviews');
  if (!reviews) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  reviews.scrollIntoView({
    block: 'start',
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
  });
}, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
